module.exports = __webpack_public_path__ + "static/media/insights.33352424.png";